import { NgModule } from '@angular/core';
import { LanguageService } from './services/language.service';

@NgModule({
  providers: [LanguageService],
})
export class LanguageModule {}
